module.exports = __webpack_public_path__ + "static/Jessica_Foster_Frame.2e924cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stories/jessica-foster/Jessica_Foster_Frame.jpg
// module id = 367
// module chunks = 118551011512839